import React from 'react'
import * as R from 'ramda'
import { makeObservable, observable } from 'mobx'
import { v4 as uuidv4 } from 'uuid'

import Switch from '../../../../UniformComponents/Switch'

class ApiKeyStore {
    constructor(store) {
        this.store = store
        makeObservable(this)
    }

   @observable data = []

   columns = []

   @observable onEditKPI = ''

   @observable rowValues = {
       apiKey: '',
       clientId: null,
       productId: null,
       portfolioId: null,
       isActive: true,
   }

   isAdd = false

   onEdit= (key, row) => {
       this.onEditKPI = key
       this.rowValues = { ...row }
   }

    handleChange = (e) => {
        const { value } = e.target
        if (e.target.name === 'isActive') {
            this.rowValues[e.target.name] = value
        } else if (!R.isNil(value) && !R.isEmpty(value) && !isNaN(parseInt(e.target.value, 10))) {
            this.rowValues[e.target.name] = parseInt(e.target.value, 10)
        } else {
            this.rowValues[e.target.name] = null
        }
    }

   setTableColumns = async () => {
       this.columns = [
           {
               name: 'Key',
               key: 'apiKey',
               cellClass: 'keyColumn',
               dataTransform: (apiKey) => (
                   <p>{apiKey ? apiKey.toUpperCase() : apiKey}</p>
               ),
           },
           {
               name: 'Client',
               key: 'clientId',
               cellClass: 'columns',
               dataTransform: (clientId, row) => {
                   if (this.onEditKPI === row.apiKey) {
                       return <input type="number" name="clientId" value={this.rowValues.clientId === 0 ? null : this.rowValues.clientId} className="numberBox" onChange={(e) => this.handleChange(e)} />
                   }
                   if (clientId !== 0) return <p>{clientId}</p>
                   return null
               },
           },
           {
               name: 'Product',
               key: 'productId',
               cellClass: 'columns',
               dataTransform: (productId, row) => {
                   if (this.onEditKPI === row.apiKey) {
                       return <input type="number" name="productId" value={this.rowValues.productId === 0 ? null : this.rowValues.productId} onChange={(e) => this.handleChange(e)} />
                   }
                   if (productId !== 0) return <p>{productId}</p>
                   return null
               },
           },
           {
               name: 'Portfolio',
               key: 'portfolioId',
               cellClass: 'columns',
               dataTransform: (portfolioId, row) => {
                   if (this.onEditKPI === row.apiKey) {
                       return <input type="number" name="portfolioId" value={this.rowValues.portfolioId === 0 ? null : this.rowValues.portfolioId} onChange={(e) => this.handleChange(e)} />
                   }
                   if (portfolioId !== 0) return <p>{portfolioId}</p>
                   return null
               },
           },
           {
               name: 'Active',
               key: 'isActive',
               cellClass: 'columns',
               dataTransform: (isActive, row) => {
                   if (row.apiKey || this.isAdd) {
                       if (this.onEditKPI === row.apiKey) {
                           return (
                               <label htmlFor="check" className="switch">
                                    <Switch
                                        state={row.isActive}
                                        onToggle={(checked) => this.handleChange({ target: { value: checked, name: 'isActive' }})}
                                    />
                               </label>
                           )
                       }
                       if (isActive) {
                           return (
                               <i className="fal fa-check" />
                           )
                       }
                       return <i className="fal fa-ban" />
                   }
                   return null
               },
           },
           {
               name: '',
               key: 'apiKey',
               cellClass: 'columns',
               dataTransform: (apiKey, row) => {
                   if (row.apiKey || this.isAdd) {
                       if (this.onEditKPI === row.apiKey) {
                           return (
                               <i
                                   className="fal fa-check"
                                   onClick={() => {
                                       if (this.isAdd) {
                                           this.addApiKeyData()
                                       } else {
                                           this.editApiKeyData()
                                       }
                                       this.onEdit('')
                                       this.isAdd = false
                                   }}
                                   aria-hidden="true"
                               />
                           )
                       }
                       return (
                           <i
                               className="fal fa-edit"
                               onClick={() => {
                                   this.onEdit(row.apiKey, row)
                                   this.isAdd = false
                               }}
                               aria-hidden="true"
                           />
                       )
                   }
                   return null
               },
           },
           {
               name: '',
               key: 'apiKey',
               cellClass: 'columns',
               dataTransform: (apiKey, row) => {
                   if (row.apiKey || this.isAdd) {
                       if (this.onEditKPI === row.apiKey) {
                           return (
                               <i
                                   className="fal fa-ban"
                                   onClick={() => {
                                       this.isAdd = false
                                       this.onEdit('')
                                   }}
                                   aria-hidden="true"
                               />
                           )
                       }
                       return (
                           <i
                               className="fal fa-trash-alt"
                               onClick={() => {
                                   this.deleteApiKeyData(row)
                               }}
                               aria-hidden="true"
                           />
                       )
                   }
                   return (
                       <i
                           className="fas fa-plus"
                           onClick={() => {
                               this.isAdd = true
                               this.onEdit(null, row)
                           }}
                           aria-hidden="true"
                       />
                   )
               },
           },
       ]
   }

   validateClientId = (obj) => {
       if (obj.clientId === 0 || obj.clientId === null) {
           throw new Error('Insert a valid Client ID')
       }
   }

   getApiKeysData =async () => {
       try {
           this.data = await this.store.http.get('/intranet/apiKey')
           this.data.push({
               apiKey: null,
               clientId: null,
               productId: null,
               portfolioId: null,
               isActive: true,
           })
       } catch (e) {
           this.store.handleError({ body: `something went wrong: ${e.message}`, level: 'error' })
       }
   }

   editApiKeyData =async () => {
       try {
           this.validateClientId(this.rowValues)
           await this.store.http.put(`/intranet/apiKey/${this.rowValues.apiKey}`, JSON.stringify(this.rowValues))
           this.store.addNotification({ body: 'API key updated', level: 'success' })
           this.getApiKeysData()
       } catch (e) {
           this.store.handleError({ body: `something went wrong: ${e.message}`, level: 'error' })
       }
   }

   addApiKeyData =async () => {
       this.rowValues.apiKey = uuidv4()
       try {
           this.validateClientId(this.rowValues)
           await this.store.http.post('/intranet/apiKey', JSON.stringify(this.rowValues))
           this.store.addNotification({ body: 'API key created', level: 'success' })
           this.getApiKeysData()
       } catch (e) {
           this.store.handleError({ body: `something went wrong: ${e.message}`, level: 'error' })
       }
   }

   deleteApiKeyData = async (row) => {
       try {
           await this.store.http.delete(`/intranet/apiKey/${row.apiKey}`)
           this.store.addNotification({ body: 'API key deleted', level: 'success' })
           this.getApiKeysData()
       } catch (e) {
           this.store.handleError({ body: `something went wrong: ${e.message}`, level: 'error' })
       }
   }
}
export default ApiKeyStore
